
import React, { useState } from 'react';
import { Separator } from "@/components/ui/separator";
import { EnrichedVisitor } from "@/types/database";
import CompanyDetails from "./components/CompanyDetails";
import SocialProfiles from "./components/SocialProfiles";
import VisitorInsightGenerator from "./components/VisitorInsightGenerator";
import { formatSocialUrl, formatPageUrl, getCompanyInitials } from "./utils/formatters";
import PersonalInformation from "./components/PersonalInformation";

interface VisitorCardContentProps {
  visitor: EnrichedVisitor;
  isOpen: boolean;
}

const VisitorCardContent = ({ visitor, isOpen }: VisitorCardContentProps) => {
  const [showPersonalInfo, setShowPersonalInfo] = useState(false);
  
  // Get formatted data
  const companyInitials = getCompanyInitials(visitor.company_name);
  const linkedinUrl = formatSocialUrl(visitor.company_linkedin_url);
  const twitterUrl = formatSocialUrl(visitor.company_twitter_url);
  const facebookUrl = formatSocialUrl(visitor.company_facebook_url);
  
  const togglePersonalInfo = () => {
    setShowPersonalInfo(prev => !prev);
  };

  return (
    <div className="space-y-6">
      <CompanyDetails 
        visitor={visitor} 
        companyInitials={companyInitials} 
        formatPageUrl={formatPageUrl} 
      />

      <Separator />

      <SocialProfiles 
        linkedinUrl={linkedinUrl}
        twitterUrl={twitterUrl}
        facebookUrl={facebookUrl}
      />

      <Separator />
      
      <PersonalInformation
        visitor={visitor}
        showPersonalInfo={showPersonalInfo}
        togglePersonalInfo={togglePersonalInfo}
      />

      <Separator />

      <VisitorInsightGenerator 
        visitor={visitor}
        isOpen={isOpen}
      />
    </div>
  );
};

export default VisitorCardContent;
